/**
 * Centralized color palette for the Connections (Canary) dashboard charts.
 *
 * Extracted so hex codes aren't scattered across the chart files -- import the
 * labeled tokens / palettes from here instead of redeclaring per component.
 */

/** Semantic colors shared across the Canary charts. */
export const CONNECTIONS_COLORS = {
  /** Above expected range / improving / net gain. */
  POSITIVE: '#1e7d32',
  /** Below expected range / worsening / net loss / flight risk. */
  NEGATIVE: '#c62828',
  /** Within expected range (amber). */
  WITHIN: '#b76e00',
  /** Primary accent (flight-risk bubbles, "other leaders"). */
  ACCENT: '#3b6fd4',
  /** Accent blue for the current-year trend line. */
  SERIES_ACCENT: '#2f7fe0',
  /** Muted grey for hidden (struck-through) legend items and the previous-year line. */
  MUTED_HIDDEN: '#9aa4c0',
  /** Dashed plot-line + median/avg axis-label text. */
  AXIS_LABEL: '#8892b0',
  /** Section-context caption text. */
  SECTION_CONTEXT: '#64708a',
  /** Neutral fallback (unknown range status). */
  NEUTRAL: '#888888',
  /** Previous-FY bar fill in the Net Internal Movement chart. */
  NET_PREV_FY: 'rgba(47,127,224,0.8)'
} as const;

/** Range-status -> color (bar borders + tooltip in CrossTeamComparison). */
export const RANGE_STATUS_COLOR: Record<'above' | 'within' | 'below', string> = {
  above: CONNECTIONS_COLORS.POSITIVE,
  within: CONNECTIONS_COLORS.WITHIN,
  below: CONNECTIONS_COLORS.NEGATIVE
};

/** Distinct per-leader palette (one color per leader, reused across themes). */
export const LEADER_SERIES_PALETTE = [
  '#2f7fe0', // blue
  '#0ea66f', // green
  '#a855f7', // purple
  '#e0457b', // magenta
  '#e0a020', // gold
  '#f0883e', // orange
  '#0d9aa8', // teal
  '#7c5cfc', // violet
  '#16a34a', // emerald
  '#c2410c', // burnt orange
  '#2563eb', // indigo
  '#db2777' // rose
];

/** Spline/series palette for the per-leader trend & trajectory charts. */
export const CHART_SERIES_PALETTE = ['#3b6fd4', '#1e7d32', '#c62828', '#b8860b', '#6a3fb5', '#0e7490', '#c2410c', '#4b5563'];
